export default [
  { id: 1, value: 'Habilidades cognitivas', option: 'Habilidades cognitivas' },
  { id: 2, value: 'Habilidades sociales', option: 'Habilidades sociales' }
]
